module.exports = "pegasus/assets/preview-7.png";